module.exports = __webpack_public_path__ + "static/media/cadd-logo-white.c2ac9f8b.svg";